// extracted by mini-css-extract-plugin
export default {"section":"Section_section__9fcuZ","content":"Section_content__Ig7rs"};